
export const REQUEST_ADDVIDEONOTE= 'REQUEST_ADDVIDEONOTE';
export const ADDVIDEONOTE_RECEIVED = 'ADDVIDEONOTE_RECEIVED';